import { render, staticRenderFns } from "./MediaLibraryInfo.vue?vue&type=template&id=3fb8c163&scoped=true&"
import script from "./MediaLibraryInfo.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryInfo.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryInfo.vue?vue&type=style&index=0&id=3fb8c163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8c163",
  null
  
)

export default component.exports